<template>
  <v-main>
    <v-container grid-list-md fluid fill-height>
      <v-layout justify-center>
        <v-flex xs12>
          <h1 class="mt-n3">{{$t("About")}}</h1>
          <p class="textsize-svs">{{$t("ScanPortal intro...")}}</p>
          <p class="textsize-svs">
            <v-carousel hide-delimiters :show-arrows="false" style="max-height: 440px"> <!-- hide-controls is obsolete. use :show-arrows="false" instead -->
              <v-carousel-item
                v-for="(item,i) in items"
                :key="i"
                :src="item.src"
                max=100
              ></v-carousel-item>
            </v-carousel>
          </p>
          <p class="textsize-svs">{{$t("Scanvaegt Systems intro...")}}</p>
          <p class="textsize-svs">{{$t("For more information please visit")}} <a href="http://www.scanvaegt.dk">Scanvaegt Systems</a>.</p>
        </v-flex>
      </v-layout>
    </v-container>
  </v-main>
</template>

<script>
import { setLang } from '@/core/lang'
import image0 from '@/assets/img/Scanvaegt0.png'
import image1 from '@/assets/img/Scanvaegt1.png'
import image2 from '@/assets/img/Scanvaegt2.png'
import image3 from '@/assets/img/Scanvaegt3.png'
import image4 from '@/assets/img/Scanvaegt4.png'
import image5 from '@/assets/img/Scanvaegt5.png'
import image6 from '@/assets/img/Scanvaegt6.png'
import image7 from '@/assets/img/Scanvaegt7.png'

export default {
  name: 'about',
  data () {
    return {
      items: [
        { src: image0 },
        { src: image1 },
        { src: image2 },
        { src: image3 },
        { src: image4 },
        { src: image5 },
        { src: image6 },
        { src: image7 }
      ]
    }
  },
  methods: {
    setLang: function (lang) {
      // Calling the setLang we imported from lang.js
      setLang(lang)
    }
  }
}
</script>
